<template>
  <textarea ref="textarea" style="max-height: 500px;min-height: 50px;overflow: hidden;resize: none;"
            @input="setValue($event.target.value)" :value="getValue" @keyup="autoGrow()" :readonly="property.readOnly"></textarea>
</template>

<script>
  import singleControlMixin from './singleControlMixin'
  export default {
    mixins: [singleControlMixin],
    name: "text-area-control",
    mounted(){
      this.autoGrow();
    },
    methods:{
      autoGrow(){//https://stackoverflow.com/questions/17772260/textarea-auto-height
        this.$refs.textarea.style.height = "5px";
        this.$refs.textarea.style.height = (this.$refs.textarea.scrollHeight)+"px";
      }
    }
  }
</script>

<style scoped>

</style>
